import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalDeleteSuccess",
  tabindex: "-1",
  "aria-labelledby": "createPost",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header mb-3" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "px-3 py-4 text-center"
}
const _hoisted_8 = {
  key: 1,
  class: "px-3 py-4 text-center"
}
const _hoisted_9 = { class: "d-flex align-items-center justify-content-center pb-3" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  checkDelete: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('titleConfirmDeletePost')), 1),
          _hoisted_6
        ]),
        (__props.checkDelete)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(translate)('SG43deleteSuccess')), 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(translate)('SG43deleteError')), 1)),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(Button, {
            title: _unref(translate)('close'),
            class: "m-w-unset",
            type: 'secondary',
            "data-bs-dismiss": "modal"
          }, null, 8, ["title"])
        ])
      ])
    ])
  ]))
}
}

})